export const CONTENT_MAX_WIDTH = "fullscreen-content-width";
export const PANEL_MAX_WIDTH = "max-w-[clamp(280px,90vw,720px)]";

export const FULLSCREEN_QUEUE_BG_CLASS = "fullscreen-queue-bg";
